import React, { useEffect, useRef, useState } from 'react';
import { Container, Grid, Modal, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Helmet } from 'react-helmet';
import { Header } from '../../../../Components/Header';
import Footer from '../../../../Components/Footer';
import BgTrilha from './Assets/bg-trilha-r1-25.png';
import BgTrilhaMobile from './Assets/bg-trilha-r1-25-mobile.png';
// import LogoR1 from './Assets/logo-trilha-r1-2025.svg';
import LogoR1 from './Assets/logo-r1-sprint.svg';
import LogoR1AbrilSprint from './Assets/logo-trilha-sprint-abril-251.png';

import FirstSectionFullScreen2024 from '../../../../Components/Sections/FirstSectionFullScreen-2024';
import FeedbackContainerSection from './components/FeedbackContainerSection';
import LearningPathSectionCarrousel from './components/LearningPathSectionCarrousel';
import Faq from './components/Faq';
import BoxInfoOqueTemMais from './components/BoxInfoOqueTemMais';
import MetricBoxInfo from './components/MetricBoxInfo';
import Api from '../../../../Services/Api';
import DefaultButton from '../../../../Components/Buttons/DefaultButton';
import IntlTelInput from 'react-intl-tel-input';

import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { trackPromise } from 'react-promise-tracker';
import Swal from 'sweetalert2';

import checkVerde from './Assets/check-green.svg';
import checkCinza from './Assets/check-gray.svg';
import PriceCardVersion4 from '../../../../Components/Cards/PriceCardVersion4';
import BagIcon from '../../../../Assets/Svg/Icons/bagIcon.svg';

const learningPathTemplate = [
	{
		title: 'Aula Hardwork',
		description: [
			'Tudo começa com a apresentação ao tema, que no Hardwork é feito com rigor em didática. ',
			<>
				<br />
				<br />
			</>,
			'São mais de 250 aulas.',
			<br />,
			'As melhores que você já viu na vida.',
		],
		bgColor: '#ffffff',
		titleColor: '#FCFCFC',
		descriptionColor: '#FCFCFC',
		url: 'https://player.vimeo.com/video/769930065',
	},
	{
		title: 'Estudo por questões',
		description: [
			'No estudo por questões o professor te conduzirá para que você entenda todas as formas em que cada tema é explorado nas provas.',
			<>
				<br />
				<br />
			</>,
			'No final, crie seu resumo de estudos e o Hardwork apontará as correções necessárias.',
		],
		bgColor: '#0D0D0D',
		titleColor: '#FCFCFC',
		descriptionColor: '#FCFCFC',
		url: 'https://player.vimeo.com/video/769929590',
	},
	{
		title: 'Revisões cíclicas e personalizadas',
		description: [
			'Questões, Flashcards e Free Recall combinados no algoritmo do Hardwork, que garante que os temas sejam vistos na quantidade exata que você precisa! É assim que revisamos no Hardwork!',
			<>
				<br />
				<br />
			</>,
			'Toda a dinâmica de revisões é, na verdade, uma continuidade do estudo por questões, explorando com mais ênfase os pontos que você tiver mais dificuldade.',
			<>
				<br />
				<br />
			</>,
			'O novo trilha traz a oportunidade de revisar de maneira inovadora: você será convidado a falar o que entendeu do tema e deixar registrado, retomando sempre que for necessário.',
		],
		bgColor: '#0D0D0D',
		titleColor: '#FCFCFC',
		descriptionColor: '#FCFCFC',
		url: 'https://player.vimeo.com/video/769929824',
	},
];

const tableData = [
	{ title: 'Trilha do aprendizado', basic: 'check', premium: 'check' },
	{ title: 'Aulas + Estudo por questões', basic: 'check', premium: 'check' },
	{
		title: [
			'Material escrito online',
			<br />,
			<p style={{ fontSize: 14, fontWeight: 400 }}>base para estudo por questões</p>,
		],
		basic: 'check',
		premium: 'check',
	},
	{
		title: [
			'Revisões personalizadas por IA',
			<br />,
			<p style={{ fontSize: 14, fontWeight: 400 }}>Questões, flashcards, free recall</p>,
		],
		basic: 'check',
		premium: 'check',
	},
	{
		title: [
			'HardworQ',
			<br />,
			<p style={{ fontSize: 14, fontWeight: 400 }}>Banco de questões com mais de 150.000 questões</p>,
		],
		basic: 'check',
		premium: 'check',
	},
	{
		title: [
			'Flashcards online',
			<br />,
			<p style={{ fontSize: 14, fontWeight: 400 }}>Mais de 10.000 flashcards</p>,
		],
		basic: 'check',
		premium: 'check',
	},
	{ title: 'Hands On online', basic: 'check', premium: 'check' },
	{
		title: [
			'Minha Biblioteca™',
			<br />,
			<p style={{ fontSize: 14, fontWeight: 400 }}>principal acervo da medicina</p>,
		],
		basic: 'check',
		premium: 'check',
	},
	{ title: 'Simulados online', basic: 'check', premium: 'check' },
	{
		title: [
			'Mentoria mensal em grupo',
			<br />,
			<p style={{ fontSize: 14, fontWeight: 400 }}>(de janeiro até outubro)</p>,
		],
		basic: 'check',
		premium: 'check',
	},
	{
		title: 'Mentoria individual',
		basic: 'x',
		premium: 'check',
		aditionalText: [<strong>03 Mentorias</strong>, ' individuais²'],
	},
	{
		title: 'Sprint Final',
		imgTitle: require('./Assets/logo-sf-res.svg').default,
		basic: 'x',
		premium: 'check',
		aditionalText: [<strong>Todas as revisões</strong>, ' direcionadas para cada banca³'],
	},
];

export default function TrilhaR1Residencia2025() {
	const classes = useStyles();
	const theme = useTheme();
	const subscribe_card_trilha_r1 = useRef(null);
	const [promotionalDate, setPromotionalDate] = useState();
	const [scroll, setScroll] = useState();
	const [group, setGroup] = useState();
	const [buttonText, setButtonText] = useState('');
	const [preInscricao, setPreInscricao] = useState({
		agrupamento: group ? `${group} - AVISE-ME` : '',
		nome: '',
		email: '',
		telefone: '',
		utm_source: '',
		utm_medium: '',
		utm_campaign: '',
	});
	const [countdownText, setCountdownText] = useState('');

	const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const matchesTablet = useMediaQuery(theme.breakpoints.down('md'));
	const [waitListVisibility, setWaitListVisibility] = useState(false);

	useEffect(() => {
		Api.get(`turmasabertas/1408`).then((res) => {
			if (res) {
				const turma = res[0];
				let targetDate = null;
				let text = '';

				// Verifica se existe um lote vigente
				if (turma?.id_lote_vigente > 0) {
					// Encontra o lote vigente pelo ID
					const loteVigente = turma?.lotes?.find((lote) => lote.id === turma.id_lote_vigente);
					// Define a data limite do lote vigente
					targetDate = new Date(loteVigente?.data_limite);
					text = `Encerramento do lote ${loteVigente?.nome} em`;
					setButtonText('Inscreva-se');
				} else {
					// Pega o primeiro lote futuro
					const primeiroLote = turma?.lotes?.find((lote) => lote.status === 'futuro');
					// Define a data de início do primeiro lote
					targetDate = new Date(primeiroLote?.data_inicio);
					text = `Abertura do lote ${primeiroLote?.nome} em`;
					setButtonText('Avise-me!');
				}

				if (targetDate) {
					setPromotionalDate(targetDate); // Atualiza o estado com a data alvo
					setCountdownText(text);
				}
			}
		});
		const handleScroll = () => {
			const scrollPosition = window.scrollY;
			if (scrollPosition > 500) {
				setScroll(true);
			} else {
				setScroll(false);
			}
		};
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const executeScroll = () => subscribe_card_trilha_r1.current.scrollIntoView({ behavior: 'smooth', block: 'end' });

	const oQueTemMaisNoTrilhaR1 = [
		{
			title: [<p style={{ color: '#FFFFFF', display: 'inline' }}>AULAS</p>, ' COM RIGOR EM DIDÁTICA'],
			icon: require('./Assets/icon-classes.svg').default,
			description: [
				'Tenha acesso imediato ao Banco de Aulas do Extensivo Hardwork 2024 e acesso progressivo às aulas da Trilha do aprendizado 2025.',
				<br />,
				'São mais de 250 aulas Hardwork, elaboradas com rigor em didática.',
			],
		},
		{
			title: [
				<p style={{ color: '#FFFFFF', display: 'inline' }}>MATERIAIS DE APOIO</p>,
				<br />,
				' AO ESTUDO POR QUESTÕES',
			],
			icon: require('./Assets/icon-support-material.svg').default,
			description:
				'Material de apoio dos principais temas explorados nas provas de residência médica, elaborado pelos professores Hardwork.',
		},
		{
			title: [
				'BANCO COM MAIS DE ',
				<br />,
				<p style={{ color: '#FFFFFF', display: 'inline' }}>100 MIL QUESTÕES</p>,
				' DE PROVAS',
			],
			icon: require('./Assets/icon-question.svg').default,
			description: 'Mais de 100 mil questões de provas dos principais concursos de residência do Brasil.',
		},
		{
			title: [<p style={{ color: '#FFFFFF', display: 'inline' }}>+ DE 200</p>, ' LIVES DE DISCUSSÃO'],
			icon: require('./Assets/icon-camera.svg').default,
			description:
				'Acesso imediato ao banco de lives do Hardwork Medicina, com discussões de mais de 200 dos principais temas voltados para provas de residência médica.',
		},
		{
			title: [<p style={{ color: '#FFFFFF', display: 'inline' }}>MENTORIA</p>],
			icon: require('./Assets/icon-mentor.svg').default,
			description:
				'Acesso a uma mentoria mensal em grupo e 02 mentorias individuais, para explorar dúvidas e dicas para os estudos e para a vida.',
		},
		// {
		// 	title: ['GRUPOS COM ', <p style={{ color: '#FFFFFF', display: 'inline' }}>TUTORIA</p>],
		// 	icon: require('./Assets/icon-tutor.svg').default,
		// 	description: 'Grupos de whatsapp com tutor, para tirar dúvidas e estimular os estudos.',
		// },
		{
			title: [
				'ACESSO A BIBILIOTECA DIGITAL COM ',
				<br />,
				<p style={{ color: '#FFFFFF', display: 'inline' }}>+ DE 7 MIL LIVROS DE MEDICINA</p>,
			],
			icon: require('./Assets/icon-library.svg').default,
			description:
				'Nada de se restringir a textos resumidos! Vamos dominar as principais fontes! Vamos te mostrar como.',
		},
		{
			title: [
				'CONTATO DIRETO COM OS ',
				<br />,
				<p style={{ color: '#FFFFFF', display: 'inline' }}>PROFESSORES</p>,
			],
			icon: require('./Assets/icon-dm-contact.svg').default,
			description:
				'Não existe escola em que o aluno não fale com o professor! Aqui o contato é direto, todos os alunos têm acesso aos professores via whatsapp.',
		},

		// {
		// 	title: ['BRINDE ', <p style={{ color: '#FFFFFF', display: 'inline' }}>KIT DE FLASHCARDS</p>],
		// 	icon: require('./Assets/icon-dm-contact.svg').default,
		// 	description:
		// 		'Não existe escola em que o aluno não fale com o professor! Aqui o contato é direto, todos os alunos têm acesso aos professores via whatsapp.',
		// },
		// {
		// 	title: [
		// 		'TREINAMENTO EXCLUSIVO ',
		// 		<br />,
		// 		<p style={{ color: '#FFFFFF', display: 'inline' }}>HARDWORK HANDS-ON ONLINE</p>,
		// 	],
		// 	icon: require('./Assets/icon-library.svg').default,
		// 	description:
		// 		'Nada de se restringir a textos resumidos! Vamos dominar as principais fontes! Vamos te mostrar como.',
		// },
	];

	const conteudos1 = [
		{
			titulo1: 'Trilha do aprendizado',
			logo: '',
			subtitle: '',
			icone: checkVerde,
		},
		{
			titulo1: 'Aulas + Estudo por questões',
			logo: '',
			subtitle: '',
			icone: checkVerde,
		},
		{
			titulo1: 'Material escrito online',
			logo: '',
			subtitle: 'base para estudo por questões',
			icone: checkVerde,
		},
		{
			titulo1: 'Revisões personalizadas por IA',
			logo: '',
			subtitle: 'Questões, flashcards, free recall',
			icone: checkVerde,
		},
		{
			titulo1: 'HardworQ',
			logo: '',
			subtitle: 'Banco de questões com mais de 150.000 questões',
			icone: checkVerde,
		},
		{
			titulo1: 'Flashcards online',
			logo: '',
			subtitle: 'Mais de 10.000 flashcards',
			icone: checkVerde,
		},
		{
			titulo1: 'Hands On online',
			logo: '',
			subtitle: '',
			icone: checkVerde,
		},
		{
			titulo1: 'Minha Biblioteca™',
			logo: '',
			subtitle: 'principal acervo da medicina',
			icone: checkVerde,
		},
		{
			titulo1: 'Simulados online',
			logo: '',
			subtitle: '',
			icone: checkVerde,
		},
		{
			titulo1: 'Mentoria mensal em grupo',
			logo: '',
			subtitle: '(de janeiro até outubro)',
			icone: checkVerde,
		},
		{
			titulo1: 'Mentoria individual',
			logo: '',
			subtitle: '',
			icone: checkCinza,
		},
		{
			titulo1: '',
			logo: require('./Assets/logo-sf-res.svg').default,
			subtitle: '',
			icone: checkCinza,
		},
	];

	const conteudos2 = [
		{
			titulo1: 'Trilha do aprendizado',
			logo: '',
			subtitle: '',
			icone: checkVerde,
		},
		{
			titulo1: 'Aulas + Estudo por questões',
			logo: '',
			subtitle: '',
			icone: checkVerde,
		},
		{
			titulo1: 'Material escrito online',
			logo: '',
			subtitle: 'base para estudo por questões',
			icone: checkVerde,
		},
		{
			titulo1: 'Revisões personalizadas por IA',
			logo: '',
			subtitle: 'Questões, flashcards, free recall',
			icone: checkVerde,
		},
		{
			titulo1: 'HardworQ',
			logo: '',
			subtitle: 'Banco de questões com mais de 150.000 questões',
			icone: checkVerde,
		},
		{
			titulo1: 'Flashcards online',
			logo: '',
			subtitle: 'Mais de 10.000 flashcards',
			icone: checkVerde,
		},
		{
			titulo1: 'Hands On online',
			logo: '',
			subtitle: '',
			icone: checkVerde,
		},
		{
			titulo1: 'Minha Biblioteca™',
			logo: '',
			subtitle: 'principal acervo da medicina',
			icone: checkVerde,
		},
		{
			titulo1: 'Simulados online',
			logo: '',
			subtitle: '',
			icone: checkVerde,
		},
		{
			titulo1: 'Mentoria mensal em grupo',
			logo: '',
			subtitle: '(de janeiro até outubro)',
			icone: checkVerde,
		},
		{
			titulo1: 'Mentoria individual',
			logo: '',
			subtitle: '03 Mentorias individuais²',
			icone: checkVerde,
		},
		{
			titulo1: '',
			logo: require('./Assets/logo-sf-res.svg').default,
			subtitle: 'Todas as revisões direcionadas para cada banca³',
			icone: checkVerde,
		},
	];

	const handleOpenWaitList = ({ idTurma }) => {
		setWaitListVisibility(true);

		if (idTurma) {
			setGroup(getGroup(idTurma));
			setPreInscricao({
				...preInscricao,
				agrupamento: getGroup(idTurma),
			});
		}
	};

	const handleCloseWaitList = () => {
		setWaitListVisibility(false);
	};

	function getGroup(id) {
		switch (id) {
			case 1408:
				return 'TRILHA R1 2025 RESIDÊNCIA';
			case 1440:
				return 'TRILHA R1 2025 RESIDÊNCIA TODOS SPRINTS';
			case 1441:
				return 'TRILHA R1 2025 RESIDÊNCIA PROVAS SP';
			case 1439:
				return 'TRILHA R1 2025 RESIDÊNCIA 1 SPRINT';
			default:
				return null;
		}
	}

	let sendPreInscricao = function () {
		if (!preInscricao.nome) {
			alert('Ops... Por favor informe seu nome');
			return;
		}
		if (!preInscricao.email || !preInscricao.email.includes('@') || !preInscricao.email.includes('.')) {
			alert('Ops... Por favor preencha seu email');
			return;
		}
		if (!preInscricao.telefone || preInscricao.telefone.length < 11) {
			alert('Ops... Por favor preencha seu telefone');
			return;
		}

		// console.log('group: ', preInscricao);
		trackPromise(
			Api.post('PreInscricao', preInscricao).then((res) => {
				if (res) {
					handleCloseWaitList();
					Swal.fire({
						title: 'Massa! ',
						text: 'Sua inscrição na lista de espera está confirmada! Avisaremos assim que a nova turma estiver liberada.',
						icon: 'success',
						confirmButtonText: 'Fechar',
						allowOutsideClick: false,
						allowEscapeKey: false,
					}).then((result) => {
						if (result.isConfirmed) {
							window.location.reload();
						}
					});
				}
			})
		);
	};

	const handlePhone = (valid, phoneNumber) => {
		if (valid) {
			setPreInscricao({
				...preInscricao,
				telefone: phoneNumber,
			});
		} else if (preInscricao.telefone.length) {
			setPreInscricao({
				...preInscricao,
				telefone: '',
			});
		}
	};

	return (
		<Container
			maxWidth={false}
			disableGutters={true}
			style={{
				backgroundColor: '#09090A',
			}}
		>
			<Helmet>
				<title>Trilha R1 2025 | A Revolução na Preparação para Residência</title>
				<meta
					name="description"
					content="Descubra a maior revolução na história da preparação para provas de
residência médica. Garanta sua vaga com o método inovador do Trilha R1
2025!"
				/>
			</Helmet>
			{matchesMobile ? null : matchesTablet ? <Header /> : null}
			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
				className="residencia"
			>
				{matchesMobile || matchesTablet ? null : <Header />}
			</Container>
			<Grid
				container
				style={{ backgroundImage: `url(${require('./Assets/bg-glitch-trilha-25.png')})` }}
			>
				<FirstSectionFullScreen2024
					backgroundImageUrl={matchesMobile ? BgTrilhaMobile : BgTrilha}
					logoUrl={LogoR1AbrilSprint}
					imageProps={{ left: '4rem' }}
					type="red"
					buttonText={buttonText}
					executeScroll={executeScroll}
					firstTextPaper={[
						<Typography
							align="left"
							color="#FCFCFC"
							fontWeight={600}
							fontFamily={'Manrope'}
							className={`${classes.firstText}`}
						>
							A maior revolução da
							<br /> história da preparação
							<br /> para Provas de Residência.
						</Typography>,
						<Typography
							align="left"
							color="#B3B3B3"
							className={`${classes.thirdText}`}
							fontFamily={'Manrope'}
							style={{ marginTop: '1rem' }}
						>
							No Trilha R1 do Hardwork caminharemos juntos na trilha do{' '}
							<strong style={{ color: '#FCFCFC' }}>aprendizado definitivo para dominar</strong> qualquer
							prova de residência do Brasil.
						</Typography>,
					]}
				/>
				<LearningPathSectionCarrousel
					title={'A Trilha do aprendizado definitivo'}
					cardsInfo={learningPathTemplate}
				/>
				<Grid
					item
					container
					style={{
						backgroundImage: `url(${require('./Assets/bg-metrics-platform.png')})`,
					}}
				>
					<Container
						fixed
						maxWidth="xl"
						disableGutters={true}
					>
						<Grid
							container
							className="section"
							direction={'column'}
							rowGap={3}
						>
							<Typography
								fontWeight={700}
								fontFamily={'Manrope'}
								color={'#FCFCFC'}
								className={classes?.subtitle1}
							>
								Métricas por avaliação de desempenho
							</Typography>
							<Grid
								container
								wrap={matchesMobile ? 'wrap' : 'nowrap'}
								columnGap={2}
								rowGap={2}
								style={{ marginTop: '1.5rem' }}
							>
								<MetricBoxInfo
									icon={require('./Assets/icon-platform.svg').default}
									title={'PLATAFORMA'}
									description={
										'A constância é a chave do sucesso. As métricas da plataforma te mostram o que você fez ao longo do tempo, quanto estudou, quantas aulas assistiu...'
									}
								/>
								<MetricBoxInfo
									icon={require('./Assets/icon-learning.svg').default}
									title={'APRENDIZADO'}
									description={
										'Acompanhe seu desempenho em cada tema e entenda seus pontos fortes e pontos que precisam de atenção.'
									}
								/>
								<MetricBoxInfo
									icon={require('./Assets/icon-institution.svg').default}
									title={'INSTITUIÇÃO'}
									description={
										'Selecione sua instituição de interesse e veja seu desempenho nos temas importantes para ela.'
									}
								/>
							</Grid>
						</Grid>
					</Container>
				</Grid>
				<Container
					fixed
					maxWidth="xl"
					disableGutters={true}
				>
					{/* <Grid
						container
						className="section"
						direction={'column'}
						rowGap={3}
						style={{ marginTop: '1.5rem' }}
					>
						<Typography
							fontWeight={700}
							fontFamily={'Manrope'}
							color={'#FCFCFC'}
							className={classes?.subtitle1}
						>
							Plataforma alinhada a sua rotina de estudo
						</Typography>
						<Grid
							item
							xs={12}
							container
							justifyContent={'space-between'}
						>
							<Grid
								item
								xs={12}
								md={5.75}
								container
								direction={'column'}
								wrap={'nowrap'}
								rowGap={2}
								style={{
									border: '1px solid #656565',
									backgroundColor: '#1D1D1D',
									borderRadius: 24,
									padding: '1.5rem',
									marginTop: '1.5rem',
								}}
							>
								<Grid
									item
									xs={12}
									md={6}
									container
									justifyContent={'center'}
								>
									<img
										src={require('./Assets/bg-plataform-trilha-r1-25.png')}
										alt=""
									/>
								</Grid>
								<Grid
									item
									xs={12}
									md={6}
									container
									alignContent={'center'}
									rowGap={2}
								>
									<BoxInfo
										title={'A plataforma que se ajusta à sua rotina!'}
										description={[
											'Os dias não são todos iguais e nem precisam ser. Ajuste seus estudos de acordo com sua rotina e tempo disponível.',
											<br />,
											<br />,
											'Selecione o tempo que vai dedicar ao estudo e a plataforma te direciona para a melhor forma de estudar: revisão, aula, estudo por questões...',
											<br />,
											<br />,
											'E tudo isso com previsão de conclusão, para que possa acompanhar e direcionar seus estudos da melhor maneira, de acordo com seus objetivos.',
										]}
									/>
								</Grid>
							</Grid>
							<Grid
								item
								xs={12}
								md={5.75}
								container
								direction={'column'}
								wrap={'nowrap'}
								rowGap={2}
								style={{
									border: '1px solid #656565',
									backgroundColor: '#1D1D1D',
									borderRadius: 24,
									padding: '1.5rem',
									marginTop: '1.5rem',
								}}
							>
								<Grid
									item
									xs={12}
									md={6}
									container
									justifyContent={'center'}
								>
									<img
										src={require('./Assets/bg-plataform-trilha-r1-25-free-recall.png')}
										alt=""
									/>
								</Grid>
								<Grid
									item
									xs={12}
									md={6}
									container
									alignContent={'center'}
									rowGap={2}
								>
									<BoxInfo
										title={'Free Recall'}
										description={[
											'E em 2025, a melhor forma de aprender e não esquecer à sua disposição!',
											<br />,
											<br />,
											'Fale sobre o tema, confronte com o material elaborado pelo Hardwork e sedimente seu conhecimento.',
											<br />,
											<br />,
											'Nas revisões, te convidaremos a refazer, para identificar pontos que precisam de atenção. Assim, o aprendizado é definitivo.',
										]}
									/>
								</Grid>
							</Grid>
						</Grid>
					</Grid> */}
					{!matchesMobile && (
						<Grid
							container
							className="section"
							direction={'column'}
							rowGap={3}
						>
							<Typography
								fontWeight={700}
								fontFamily={'Manrope'}
								color={'#FCFCFC'}
								className={classes.subtitle1}
							>
								O que mais tem no Trilha R1 2025
							</Typography>
							<Grid
								item
								container
								justifyContent={'center'}
								alignItems={'center'}
								gap={2}
							>
								{oQueTemMaisNoTrilhaR1.map((elm, i) => {
									return (
										<BoxInfoOqueTemMais
											key={i}
											title={elm?.title}
											icon={elm.icon}
											description={elm.description}
										/>
									);
								})}
							</Grid>
						</Grid>
					)}
				</Container>
				{/*<Container*/}
				{/*	fixed*/}
				{/*	maxWidth="xl"*/}
				{/*	disableGutters={true}*/}
				{/*>*/}
				{/*	<Grid*/}
				{/*		container*/}
				{/*		className="section"*/}
				{/*		direction={'column'}*/}
				{/*		rowGap={3}*/}
				{/*		marginBottom={5}*/}
				{/*	>*/}
				{/*		<Typography*/}
				{/*			fontWeight={700}*/}
				{/*			fontFamily={'Manrope'}*/}
				{/*			color={'#FCFCFC'}*/}
				{/*			className={classes.subtitle1}*/}
				{/*		>*/}
				{/*			Para completar a jornada...*/}
				{/*		</Typography>*/}
				{/*		<BoxTextAndImage*/}
				{/*			title={'Kit de Flashcards'}*/}
				{/*			description={*/}
				{/*				matchesMobile*/}
				{/*					? 'Receba o kit físico de Flashcards criados pelos professores Hardwork que abordam os temas mais quentes das provas de residência médica.'*/}
				{/*					: [*/}
				{/*							'Receba o kit físico de Flashcards criados pelos professores Hardwork que abordam os temas mais quentes das provas de residência médica.',*/}
				{/*						]*/}
				{/*			}*/}
				{/*			img={require('./Assets/img-flashcards.png')}*/}
				{/*		/>{' '}*/}
				{/*		<BoxTextAndImage*/}
				{/*			title={'Hands-On online'}*/}
				{/*			description={*/}
				{/*				matchesMobile*/}
				{/*					? 'Treinamento de habilidades práticas online. Vias aéreas, suporte ventilatório, POCUS, sutura e pequenos procedimentos, atendimento a trauma, reanimação adulto e criança, entre outros.'*/}
				{/*					: [*/}
				{/*							[*/}
				{/*								'Treinamento de habilidades práticas online.',*/}
				{/*								<br />,*/}
				{/*								'Vias aéreas, suporte ventilatório, POCUS, sutura e pequenos',*/}
				{/*								<br />,*/}
				{/*								'procedimentos, atendimento a trauma, reanimação adulto e',*/}
				{/*								<br />,*/}
				{/*								'criança, entre outros.',*/}
				{/*							],*/}
				{/*						]*/}
				{/*			}*/}
				{/*			img={require('./Assets/logo-hands-on.svg').default}*/}
				{/*			invert*/}
				{/*		/>{' '}*/}
				{/*	</Grid>*/}
				{/*</Container>*/}

				<Grid
					item
					xs={12}
					container
					style={{
						backgroundImage: `url(${require('./Assets/bg-gradient-price-card-trilha-r1-25.png')})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}
				>
					<Container
						fixed
						maxWidth="xl"
						disableGutters={true}
						className="residencia"
					>
						<Grid
							container
							className="section"
							rowGap={3}
							ref={subscribe_card_trilha_r1}
						>
							<Grid
								item
								xs={12}
								container
								alignItems={'center'}
								justifyContent={'space-between'}
							>
								<Typography
									fontWeight={700}
									fontFamily={'Manrope'}
									color={'#FCFCFC'}
									className={`${classes.subtitle1} gradient-text-sprint-default `}
								>
									Garanta sua inscrição!
								</Typography>
								<div
									style={{
										backgroundColor: 'white',
										color: 'black',
										fontWeight: 'bold',
										width: 'fit-content',
										height: 'fit-content',
										borderRadius: '16px',
										padding: '8px 16px',
										fontSize: '14px',
									}}
								>
									<p>20% de desconto para ex-alunos¹</p>
								</div>
							</Grid>

							<Container
								fixed
								maxWidth="xl"
								disableGutters={true}
							>
								<Grid
									container
									alignContent="center"
									justifyContent="center"
									className={`${matchesTablet ? null : 'section'}  -live-card`}
									style={{
										backgroundColor: 'black',
										borderRadius: 15,
										margin: matchesTablet ? '40px auto' : '80px auto',
									}}
								>
									<PriceCardVersion4
										idTurma={1471}
										logo={LogoR1AbrilSprint}
										iconBtn={BagIcon}
										color
										setPromotionalDate={setPromotionalDate}
									/>
								</Grid>
							</Container>

							{/*<PriceCardAndTable*/}
							{/*	idTurma1={1408}*/}
							{/*	idTurma2={1440}*/}
							{/*	tableData={tableData}*/}
							{/*/>*/}
							<Grid
								item
								xs={12}
								container
								direction={'column'}
								alignItems={'center'}
								rowGap={1}
								// justifyContent={'center'}
							>
								<Typography
									fontFamily={'Manrope'}
									fontSize={12}
									color={'#F5F5F5'}
								>
									¹<strong>20%</strong> de desconto para ex-alunos Trilha ou <strong>10%</strong> de
									desconto para ex-alunos Sprint.
								</Typography>
								<Typography
									fontFamily={'Manrope'}
									fontSize={12}
									color={'#F5F5F5'}
								>
									²As <strong>datas</strong> e <strong>horários</strong> disponíveis para agendar as
									mentorias serão liberadas dentro da plataforma.
								</Typography>
								<Typography
									fontFamily={'Manrope'}
									fontSize={12}
									color={'#F5F5F5'}
								>
									³Acesso a <strong>todas as revisões focadas para cada banca</strong> de residência e
									acesso direto 2025, disponibilizadas próximas às datas das provas.
								</Typography>
								{/*<Typography*/}
								{/*	fontFamily={'Manrope'}*/}
								{/*	fontSize={12}*/}
								{/*	color={'#F5F5F5'}*/}
								{/*>*/}
								{/*	⁴Os brindes (kit de flashcards) ficarão disponíveis por tempo limitado e serão*/}
								{/*	enviados a partir de fevereiro.*/}
								{/*</Typography>*/}
							</Grid>
						</Grid>
					</Container>
				</Grid>

				{/*{matchesMobile && (*/}
				{/*	<div*/}
				{/*		ref={subscribe_card_trilha_r1}*/}
				{/*		style={{ backgroundColor: '#303030', padding: '4rem 1rem', fontFamily: 'Manrope' }}*/}
				{/*	>*/}
				{/*		<Typography*/}
				{/*			align="left"*/}
				{/*			color="primary"*/}
				{/*			className={`gradient-text-enare-2`}*/}
				{/*			fontFamily={'Manrope'}*/}
				{/*			style={{ fontWeight: 600, fontSize: '32px' }}*/}
				{/*		>*/}
				{/*			Garanta sua inscrição!*/}
				{/*		</Typography>*/}
				{/*		<div*/}
				{/*			style={{*/}
				{/*				backgroundColor: 'white',*/}
				{/*				color: 'black',*/}
				{/*				fontWeight: 'bold',*/}
				{/*				width: 'fit-content',*/}
				{/*				borderRadius: '16px',*/}
				{/*				padding: '2px 12px',*/}
				{/*				fontSize: '14px',*/}
				{/*			}}*/}
				{/*		>*/}
				{/*			<p>20% de desconto para ex-alunos¹</p>*/}
				{/*		</div>*/}
				{/*		<BoxInfoOqueTemMobile*/}
				{/*			conteudos={conteudos1}*/}
				{/*			turmaTrilha={1408}*/}
				{/*			logo={require('./Assets/logo-r1-25-basic.svg').default}*/}
				{/*		/>*/}
				{/*		<BoxInfoOqueTemMobile*/}
				{/*			conteudos={conteudos2}*/}
				{/*			turmaTrilha={1440}*/}
				{/*			logo={require('./Assets/logo-r1-25-premium.svg').default}*/}
				{/*		/>*/}
				{/*		<Grid*/}
				{/*			item*/}
				{/*			xs={12}*/}
				{/*			container*/}
				{/*			direction={'column'}*/}
				{/*			alignItems={'center'}*/}
				{/*			rowGap={1}*/}
				{/*			style={{ marginTop: '2.5rem', padding: '0 1.5rem' }}*/}
				{/*		>*/}
				{/*			<Typography*/}
				{/*				fontFamily={'Manrope'}*/}
				{/*				fontSize={12}*/}
				{/*				color={'#F5F5F5'}*/}
				{/*				align="center"*/}
				{/*			>*/}
				{/*				¹<strong>20%</strong> de desconto para ex-alunos Trilha ou <strong>10%</strong> de*/}
				{/*				desconto para ex-alunos Sprint.*/}
				{/*			</Typography>*/}
				{/*			<Typography*/}
				{/*				fontFamily={'Manrope'}*/}
				{/*				fontSize={12}*/}
				{/*				color={'#F5F5F5'}*/}
				{/*				align="center"*/}
				{/*			>*/}
				{/*				²As <strong>datas</strong> e <strong>horários</strong> disponíveis para agendar as*/}
				{/*				mentorias serão liberadas dentro da plataforma.*/}
				{/*			</Typography>*/}
				{/*			<Typography*/}
				{/*				fontFamily={'Manrope'}*/}
				{/*				fontSize={12}*/}
				{/*				color={'#F5F5F5'}*/}
				{/*				align="center"*/}
				{/*			>*/}
				{/*				³Acesso a <strong>todas as revisões focadas para cada banca</strong>, disponibilizadas*/}
				{/*				próximas às datas das provas.*/}
				{/*			</Typography>*/}
				{/*			<Typography*/}
				{/*				fontFamily={'Manrope'}*/}
				{/*				fontSize={12}*/}
				{/*				color={'#F5F5F5'}*/}
				{/*				align="center"*/}
				{/*			>*/}
				{/*				⁴Os brindes (kit de flashcards) ficarão disponíveis por tempo limitado e serão enviados*/}
				{/*				a partir de fevereiro.*/}
				{/*			</Typography>*/}
				{/*		</Grid>*/}
				{/*	</div>*/}
				{/*)}*/}
				<FeedbackContainerSection
					type={'residencia'}
					title={'Depoimentos de nossos alunos'}
				/>
				<Container
					fixed
					maxWidth="xl"
					disableGutters={true}
				>
					<Grid
						container
						className="section"
						rowGap={2}
					>
						<Typography
							fontWeight={700}
							fontFamily={'Manrope'}
							color={'#FCFCFC'}
							style={{ fontSize: '2.5rem' }}
						>
							FAQ
						</Typography>
						<Faq />
					</Grid>
				</Container>
			</Grid>
			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
			>
				{' '}
				{matchesTablet ? null : <Footer />}
			</Container>
			{matchesTablet ? <Footer /> : null}
			{/* <CounterDown
				scrollToPayment={executeScroll}
				text={countdownText}
				date={promotionalDate}
				colorStartButton={'#FF5F45'}
				colorEndButton={'#FF357D'}
				btnText={buttonText}
			/> */}
			<Modal
				open={waitListVisibility}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Grid
					container
					justifyContent={'center'}
					alignItems={'center'}
					style={{
						backgroundColor: '#fcfcfc',
						width: matchesTablet ? '90%' : '35%',
						padding: '1rem',
						borderRadius: 18,
					}}
				>
					<form
						className="form-control"
						style={{
							width: '100%',
						}}
					>
						<Grid
							item
							xs={12}
							container
							justifyContent={'center'}
						>
							<Grid
								item
								container
								justifyContent="space-between"
							>
								<Typography
									color="primary"
									className={`${classes.textWaitList} poppins`}
								>
									Inscrever-se na Lista de Espera
								</Typography>
								<CancelRoundedIcon
									onClick={() => handleCloseWaitList()}
									className={classes.cancelIcon}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								md={6}
								container
								justifyContent={matchesTablet ? 'center' : 'flex-start'}
							>
								<TextField
									fullWidth
									type="string"
									name="nome"
									placeholder="Seu nome completo"
									required={true}
									InputProps={{
										className: `${classes.form} ${classes.formHeight}`,
									}}
									InputLabelProps={{
										shrink: true,
									}}
									style={matchesTablet ? { width: '100%' } : { width: '97%' }}
									onChange={(e) =>
										setPreInscricao({
											...preInscricao,
											nome: e.target.value,
										})
									}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								md={6}
								container
								justifyContent={matchesTablet ? 'center' : 'flex-end'}
								alignContent={'center'}
							>
								<IntlTelInput // Componente Input de telefones internacionais
									name="telefone"
									type="telefone"
									preferredCountries={['BR', 'PY', 'AR', 'CL', 'BO', 'UY', 'CU', 'PT']}
									style={{ width: '100%' }}
									inputClassName={`${classes.phoneNumberForm} ${classes.form} ${classes.formHeight}`}
									nationalMode={true}
									onPhoneNumberChange={(valid, value, selectedCountryData, fullNumber) =>
										handlePhone(valid, fullNumber)
									}
								/>
							</Grid>
							<Grid
								item
								xs={12}
								container
								justifyContent={matchesMobile ? 'center' : 'flex-start'}
							>
								<TextField
									fullWidth
									type="email"
									name="email"
									placeholder="Seu melhor e-mail"
									required={true}
									InputProps={{
										className: `${classes.form} ${classes.formHeight}`,
									}}
									InputLabelProps={{
										shrink: true,
									}}
									style={{ width: '100%' }}
									onChange={(e) =>
										setPreInscricao({
											...preInscricao,
											email: e.target.value,
										})
									}
								/>
							</Grid>
							{group && (
								<Grid
									item
									xs={12}
									md={10}
									lg={8}
									container
									className="residencia"
									style={{ height: 50, padding: '4px 0px' }}
								>
									<DefaultButton
										variant="outlined"
										color="secondary"
										className={`${classes.btnWaitList} btn`}
										onClick={() => sendPreInscricao()}
									>
										&nbsp; Confirmar inscrição
									</DefaultButton>
								</Grid>
							)}
						</Grid>
					</form>
				</Grid>
			</Modal>
		</Container>
	);
}

const useStyles = makeStyles((theme) => ({
	title: {
		fontWeight: 'bold !important',
		fontSize: '3.5em !important',
		lineHeight: '1 !important',
	},
	firstText: {
		fontSize: '2.25rem !important',
		lineHeight: 'unset !important',
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.25rem !important',
		},
	},
	secondText: {
		fontSize: '2.5rem !important',
		lineHeight: 'unset !important',
		color: '#FCFCFC !important',
		[theme.breakpoints.down('xl')]: {
			fontSize: '2rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.25rem !important',
		},
	},
	thirdText: {
		fontSize: '1.25rem !important',
		[theme.breakpoints.down('sm')]: {
			fontSize: '1rem !important',
		},
	},
	text: {
		fontSize: '1.15rem !important',
		lineHeight: '1.25 !important',
		[theme.breakpoints.down('xl')]: {
			fontSize: '1rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.9rem !important',
		},
	},
	subtitle1: {
		fontSize: '3rem !important',
		fontWeight: 'bold !important',
		[theme.breakpoints.down('md')]: {
			lineHeight: 'unset !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.5rem !important',
			lineHeight: 'unset !important',
		},
	},
	scriptText: {
		fontSize: '0.95rem !important',
		overflowY: 'auto',
		paddingRight: 20,
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.8rem !important',
			maxHeight: 175,
			minHeight: 'unset !important',
		},
	},
	gridButton: {
		bottom: 25,
		left: '-5%',
		[theme.breakpoints.down('lg')]: {
			bottom: -17,
		},
		[theme.breakpoints.down('sm')]: {
			left: '-7%',
			bottom: -15,
		},
	},
	btn: {
		fontSize: '1rem !important',
		backgroundColor: '#33C96F !important',
		fontWeight: 'bold !important',
		'&:hover': {
			scale: 1.05,
			color: '#ffffff !important',
			'& $logoBtn': {
				filter: 'invert(0)',
			},
		},
		[theme.breakpoints.down('lg')]: {
			fontSize: '0.75rem !important',
			minHeight: 'unset !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.75rem !important',
			width: '50%',
		},
	},
	gridTextSecondSection: {
		paddingBottom: 70,
		[theme.breakpoints.down('lg')]: {
			paddingBottom: 35,
		},
	},
	textSecondSection: {
		fontSize: '1.85rem !important',
		lineHeight: '1.25 !important',
		[theme.breakpoints.down('lg')]: {
			fontSize: '1.4rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1rem !important',
		},
	},
	btnDetail: {
		fontWeight: 'bold',
		width: '100%',
		maxHeight: 50,
		[theme.breakpoints.down('lg')]: {
			width: '100%',
		},
		[theme.breakpoints.down('sm')]: {
			width: '25%',
			fontSize: '.8rem !important',
		},
	},
	gridButtonDetails: {
		bottom: 5,
		left: '70%',
		[theme.breakpoints.down('lg')]: {
			bottom: 20,
		},
		[theme.breakpoints.down('sm')]: {
			left: '-3%',
			bottom: 40,
		},
	},
	gridBtnHeight: {
		transition: 'all .2s',
		display: 'flex',
		alignContent: 'flex-start',
	},
	description: {
		display: 'inline-block',
		fontSize: '1.25rem !important',
		[theme.breakpoints.down('sm')]: {
			width: '100%',
			fontSize: '1rem !important',
		},
	},
	descriptionGrid: {
		width: '100% !important',
		margin: '1.5rem 0rem 1.5rem 0rem',
		transition: 'all 0.5s ease',
	},
	subtitle: {
		fontSize: '2.85rem !important',
		fontWeight: 'bold !important',
		lineHeight: 'unset !important',
		// marginBottom: '1rem !important',
		[theme.breakpoints.down('lg')]: {
			fontSize: '2.25rem !important',
		},
		[theme.breakpoints.down('md')]: {
			fontSize: '1.75rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.5rem !important',
			marginBottom: '0.5rem !important',
		},
	},
	focusImg: {
		position: 'absolute !important',
		top: 260,
		zIndex: 1,
		left: 215,
		width: '35%',
		[theme.breakpoints.up('xl')]: {
			top: 300,
		},
		[theme.breakpoints.down('lg')]: {
			left: 180,
			top: 230,
			// width: '45%',
		},
		[theme.breakpoints.down('md')]: {
			left: 60,
			// bottom: -45,
		},
	},
	strategyImg: {
		position: 'absolute',
		top: 300,
		zIndex: 1,
		right: 200,
		width: '50%',
		[theme.breakpoints.up('xl')]: {
			top: 360,
		},
		[theme.breakpoints.down('lg')]: {
			right: 130,
			top: 250,
			width: '40%',
		},
		[theme.breakpoints.down('md')]: {
			right: 130,
			width: '15%',
		},
	},
	sweatImg: {
		position: 'absolute',
		top: 320,
		zIndex: 1,
		left: 200,
		width: '50%',
		[theme.breakpoints.up('xl')]: {
			top: 360,
		},
		[theme.breakpoints.down('lg')]: {
			left: 130,
			top: 290,
			width: '40%',
		},
		[theme.breakpoints.down('md')]: {
			width: '15%',
		},
	},
	btnFirstSection: {
		// display: 'none',
		position: 'fixed !important',
		zIndex: '1500',
		border: '5px solid black !important',
		width: 'fit-content',
		padding: '0 3rem !important',
		bottom: '3rem',
		right: '3rem',
		fontSize: '1.425rem !important',
		fontWeight: 'bold !important',
		'&:hover': {
			scale: 1.05,
			color: '#ffffff',
			'& $logoBtn': {
				filter: 'invert(0%) !important',
			},
		},
		[theme.breakpoints.down('lg')]: {
			fontSize: '1rem !important',
			minHeight: 'unset !important',
			width: 'fit-content',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.9rem !important',
			width: 'fit-content',
		},
	},
	firstSectionText: {
		fontSize: '2rem !important',
		lineHeight: '1.25 !important',
		[theme.breakpoints.down('lg')]: {
			fontSize: '1.5rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			marginTop: '8px !important',
			fontSize: '1.25rem !important',
		},
	},
	secondSectionText: {
		fontSize: '2rem !important',
		lineHeight: '1.25 !important',
		// [theme.breakpoints.down('lg')]: {
		// 	fontSize: '1.5rem !important',
		// },
		[theme.breakpoints.down('sm')]: {
			fontSize: '1rem !important',
		},
	},

	checkIcon: {
		color: '#FCFCFC',
		fontSize: '1rem !important',
	},
	btnWaitList: {
		fontSize: '1rem !important',
		minHeight: 'unset !important',
		fontWeight: 'bold !important',
		backgroundColor: '#00AB55 !important',
		border: '1px solid #707070 !important',
		[theme.breakpoints.up('lg')]: {
			'&:hover': {
				minWidth: '72% !important',
				fontSize: '1.025rem !important',
				backgroundColor: '#00543b !important',
				transition: '0.1s',
			},
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.85rem !important',
		},
	},
	form: {
		borderRadius: '8px !important',
		backgroundColor: '#E1E1E1 !important',
		margin: '5px 0 !important',
	},
	formHeight: {
		maxHeight: '3em',
	},
	phoneNumberForm: {
		height: '3em',
		borderRadius: 8,
		width: '100%',
		border: 'unset',
	},
	textWaitList: {
		fontSize: '1.3rem !important',
		fontWeight: 'bold !important',
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.95rem !important',
		},
	},
	cancelIcon: {
		color: '#000000',
		top: '-5px',
		'&:hover': {
			cursor: 'pointer',
		},
		[theme.breakpoints.down('sm')]: {
			position: 'absolute',
			top: '-10px',
			right: '-10px',
		},
	},
}));
